export default __webpack_public_path__ + "static/media/NancyCushing-Jones.7ddf1032.jpeg";